export interface SimulationProgress {
  simRunning: boolean;
  percent: number;
}

export class SimulationProgress {

  public simRunning: boolean;
  public percent: number;

  constructor(param: SimulationProgress = {
    simRunning: false,
    percent: 0,
  }) {
    this.simRunning = param.simRunning;
    this.percent = param.percent;
  }
}
